module.exports = __webpack_public_path__ + "img/ic_hj_mode_casual.590ee256.png";